export const USER_DICTIONARY = [
  {
    options: "login",
    save: { store: false, self: true },
    load: "self",
    keyName: "user_name",
    valueName: "user_name",
  },
  {
    options: "user_firstname",
    save: { store: false, self: true },
    load: "self",
    keyName: "user_firstname",
    valueName: "user_firstname",
  },
  {
    options: "user_lastname",
    save: { store: false, self: true },
    load: "self",
    keyName: "user_lastname",
    valueName: "user_lastname",
  },
  {
    options: "user_middlename",
    save: { store: false, self: true },
    load: "self",
    keyName: "user_middlename",
    valueName: "user_middlename",
  },
];
export const USER_REQUIRED_FILEDS = {
  user_name: true,
  user_firstname: true,
  user_lastname: true,
  user_middlename: true,
}
export const USER_COLUMNS = [
  {
    header: "ID",
    field: "user_id",
    sortable: true,
    bodyStyle: "text-align: right; width:65px;",
    filterData: {
      type: "InputText",
      attrList: { type: "number", step: "1" },
      placeholder: "...",
    },
    editor: {
      name: "InputText",
      style: (value) => {
        if (value < 0) return { color: "white" };
        return null;
      },
      attrList: {
        disabled: true,
        style: "width: 60px",
      },
    },
  },
  {
    header: "Пользователь",
    field: "user_name",
    sortable: true,
    bodyStyle: "width:120px;",
    filterData: {
      options: "login",
      type: "Dropdown",
      mode: "equals",
      attrList: { filter: true },
    },
    editor: {
      name: "InputText",
    },
  },
  {
    header: "Фамилия",
    field: "user_lastname",
    sortable: true,
    filterData: {
      options: "user_lastname",
      type: "MultiSelect",
      mode: "in",
      attrList: { filter: true },
    },
    editor: {
      name: "InputText",
    },
  },
  {
    header: "Имя",
    field: "user_firstname",
    sortable: true,
    filterData: {
      options: "user_firstname",
      type: "MultiSelect",
      mode: "in",
      attrList: { filter: true },
    },
    editor: {
      name: "InputText",
    },
  },
  {
    header: "Отчество",
    field: "user_middlename",
    sortable: true,
    filterData: {
      options: "user_middlename",
      type: "MultiSelect",
      mode: "in",
      attrList: { filter: true },
    },
    editor: {
      name: "InputText",
    },
  },
  {
    header: "Почта",
    field: "user_mail",
    tooltip: "user_mail",
    bodyStyle: "overflow: hidden; width:100px;",
    sortable: true,
    filterData: {
      type: "InputText",
      placeholder: "...",
    },
    editor: {
      name: "InputText",
      attrList: { style: 'width:100px;', },
    },
  },
  {
    header: "Тел.",
    field: "user_phone",
    tooltip: "user_phone",
    sortable: true,
    editor: {
      name: "InputText",
      attrList: { style: 'width:100px;', },
    },
  },
  {
    header: "Моб. тел.",
    field: "user_mobile_phone",
    tooltip: "user_mobile_phone",
    sortable: true,
    visible: false,
    editor: {
      name: "InputText",
      attrList: { style: 'width:100px;', },
    },
  },
  {
    header: "Должн.",
    field: "post_name",
    tooltip: "post_name",
    sortable: true,
    visible: false,
    editor: {
      name: "InputText",
      attrList: { style: 'width:100px;', },
    },
  },
  {
    header: "Хеш",
    field: "user_password_hash",
    bodyStyle: "text-align: center;  width:50px;",
    dataType: "component",
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
  },
  {
    header: "Андр.",
    field: "android_access",
    sortable: true,
    bodyStyle: "text-align: center;  width:100px;",
    dataType: "component",
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
    editor: {
      name: "checkbox",
      attrList: {
        binary: true,
      },
    },
    filterData: {
      attrList: {
        options: [{ android_access: false }, { android_access: true }],
      },
      type: "Dropdown",
      mode: "equals",
      label: "name",
    },
  },
  {
    header: "Андр. #/#",
    field: "user_device_count",
    tooltip: "user_device_count",
    bodyStyle: "text-align: center; width:74px;",
  },
  {
    header: "Актуал.",
    field: "user_actual",
    sortable: true,
    bodyStyle: "text-align: center; width:100px; ",
    dataType: "component",
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
    editor: {
      name: "checkbox",
      attrList: {
        binary: true,
      },
    },
    filterData: {
      attrList: {
        options: [{ user_actual: false }, { user_actual: true }],
      },
      type: "Dropdown",
      mode: "equals",
      label: "name",
    },
  },
];
export const ROLE_COLUMNS = [{
  header: "Наименование",
  field: "role_name",
  editor: {
    name: "InputText",
  },
},
{
  header: "Системное имя",
  field: "role_sysname",
  editor: {
    name: "InputText",
  },
}
];